// extracted by mini-css-extract-plugin
module.exports = {"containerHome":"Home_containerHome__3M4X4","selectors":"Home_selectors__2AVdl"};